export default "__VITE_ASSET__CfsLGmxb__"